module.exports = __webpack_public_path__ + "static/media/ig-box.a336b403.png";